import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MasterService } from '../services/master-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';


@Component({
  //selector: 'app-root',
  templateUrl: '../main.component.html'
})

export class UserListComponent implements OnInit {
  public menuName = "Master";
  public titleName = "User";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = true;
  public isSearchDate = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  first_flg: boolean = true;
  loading_flg: boolean = true;
  //invalidInput: boolean;

  //get source
  constructor(private _masterService: MasterService, private _router: Router, public dialog: MatDialog, private _com: CommonService) {
  }

  ngOnInit() {
    this.getUsers();
    //this.getGender();
  }

  getUsers() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._masterService.getUsers(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).user_id;
    let dialogRef = this.dialog.open(PopupUserComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        user_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getUsers();
      });
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }
  //dropDownSource: string[] = ['Id','Full Name', 'Role', 'User Name', 'Password', 'Inactive'];
  dropDownSource: string[] = ['Id','Full Name', 'User Name', 'Password', 'Inactive'];
  //groups: any[] = ['role_id'];
  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'user_id', type: 'int' },
        { name: 'full_name', type: 'string' },
        { name: 'user_name', type: 'string' },
        { name: 'pwd', type: 'string' },
        //{ name: 'role_id', type: 'int' },
        //{ name: 'role_name', type: 'string' },
        { name: 'inactive', type: 'bool' }
      ],
      id: 'user_id',
      localdata: {},
      sortcolumn: 'user_id'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  ////dropdown 
  //sourceGender: any =
  //  {
  //    datatype: 'array',
  //    datafields: [
  //      { name: 'sort', type: 'int' },
  //      { name: 'value', type: 'string' }
  //    ],
  //    localdata: {}
  //  };
  //dataAdapterGender: any = new jqx.dataAdapter(this.sourceGender);

  roles: any[] = [
    { role_id: 1, role_name: 'Admin' },
    { role_id: 2, role_name: 'Super User' },
    { role_id: 3, role_name: 'General User' }
  ];
  //rolesSource: any =
  //  {
  //    datatype: 'array',
  //    datafields: [
  //      { name: 'role_name', type: 'string' },
  //      { name: 'role_id', type: 'int' }
  //    ],
  //    localdata: this.roles
  //  };
  //rolesAdapter: any = new jqx.dataAdapter(this.rolesSource, { autoBind: true });

  getWidth(): any {
    //if (document.body.offsetWidth < 800) {
    //  return '90%';
    //}

    return '100%';
  }

  getTotal(): any {
    return false;
  }
  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'user_id', width: '10%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false },
      {
        text: 'Full Name', datafield: 'full_name', width: '40%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 50) {
            return { result: false, message: 'Full Name must be less than 50 letters.' };
          }
          return true;
        }
      },
      //{
      //  text: 'Role', datafield: 'role_id', displayfield: 'role_name', width: '20%', columntype: 'dropdownlist',
      //  createeditor: (row: number, column: any, editor: any): void => {
      //    // assign a new data source to the dropdownlist.
      //    //let list = ['Admin', 'Super User', 'General User'];
      //    editor.jqxDropDownList({ autoDropDownHeight: true, source: this.rolesAdapter, displayMember: 'role_name', valueMember: 'role_id' });
      //  },
      //  validation: (cell: any, value: any): any => {
      //    if (value == '') {
      //      return { result: false, message: 'Role is required.' };
      //    }
      //    return true;
      //  }
      //},
      {
        text: 'User Name', datafield: 'user_name', width: '20%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'User Name is requried.' };
          }
          else if (value.length > 50) {
            return { result: false, message: 'User Name must be less than 50 letters.' };
          }
          return true;
        }
      },
      {
        text: 'Password', datafield: 'pwd', width: '20%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Password is requried.' };
          }
          else if (value.length > 50) {
            return { result: false, message: 'Password must be less than 50 letters.' };
          }
          return true;
        }
      },
      { text: 'Inactive', datafield: 'inactive', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false }
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    //return '<div style="width: 100%; height: 100%; background-color: ' + color + '; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';

    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  //generatedata(): any {
  //  let row = {};
  //  row['user_id'] = 0;
  //  row['full_name'] = "";
  //  row['role_name'] = "";
  //  row['user_name'] = "";
  //  row['pwd'] = "";
  //  row['inactive'] = false;

  //  return row;
  //}

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
//    saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
//    deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
//    saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
//    deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
//    saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
//    buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
//    buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupUserComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          user_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getUsers();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      //this.myGrid.source(this.getAdapter());
      //this.myGrid.source(this.source);
      this.getUsers();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let user = this.myGrid.getrowdata(i);
    //    if ( user.full_name.length > 50
    //      || user.role_id == ''
    //      || user.user_name == ''
    //      || user.user_name.length > 50
    //      || user.pwd == ''
    //      || user.pwd.length > 50) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  let rows = this.myGrid.getrows();

    //  rows.forEach(user => {
    //    if (user.user_id == 0) {
    //      this._masterService.addUser(user)
    //        .subscribe(
    //          data => {
    //            //this.getUsers(true);
    //            let index = this.myGrid.getrowboundindexbyid(user.user_id);
    //            user.user_id = data;
    //            this.myGrid.setcellvalue(index, "user_id", data);
    //            this.myGrid.expandallgroups();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved: " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._masterService.updateUser(user)
    //        .subscribe(
    //          data => {
    //          //this.getUsers();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved: " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(userId => {
    //    if (userId != "0") {
    //      this._masterService.deleteUser(userId).subscribe(
    //        data => {
    //          //this.getUsers();
    //          if (data != 1) {
    //            this.errorMessage += "Data has not been found : ID " + userId;
    //          }
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved: " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;

    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'user_id';
        break;
      case 1:
        datafield = 'full_name';
        break;
      //case 2:
      //  datafield = 'role_name';
      //  break;
      case 2:
        datafield = 'user_name';
        break;
      case 3:
        datafield = 'pwd';
        break;
      case 4:
        datafield = 'inactive';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  btnOnClick() {
    let gridContent = this.myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>jQWidgets Grid</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  excelBtnOnClick() {
    this.myGrid.exportdata('xls', 'User');
  };

  //getGender() {
  //  this._masterService.getGenderList().subscribe((data) => {
  //    this.sourceGender.localdata = data;
  //    this.dataAdapterGender.dataBind();
  //  });
  //}

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}


//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-user',
  templateUrl: 'popup-user.component.html',
  styleUrls: ['./master-popup.component.css'],
})
export class PopupUserComponent implements OnInit {
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  user: any;

  roles: any[] = [
    { role_id: 1, role_name: 'Admin' },
    { role_id: 2, role_name: 'Super User' },
    { role_id: 3, role_name: 'General User' }
  ];

  constructor(
    public dialogRef: MatDialogRef<PopupUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      user_id: 0,
      full_name: '',
      user_name: ['', Validators.required],
      pwd: ['', Validators.required],
      role_id: 0,
      role_name: '',
      updated_by: this.user,
      updated_date: todayStr,
      inactive: false
    })
  }

  ngOnInit() {
    this.getUserById(this.data.user_id);
  }

  ngAfterViewInit(): void {
  }

  getUserById(id) {
    if (id > 0) {
      this.title = '(Edit/View)'
      this._masterService.getUserById(id)
        .subscribe(
          res => {
            this.Form.setValue(res);
          },
          error => this.errorMessage = error
        );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveUser() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    if (this.user_id.value == 0) {
      this._masterService.addUser(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully added the data.";
              this.getUserById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      this._masterService.updateUser(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getUserById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  //Delete Data
  deleteUser() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.user_id.value != 0) {

      let id = this.user_id.value;

      this._masterService.deleteUser(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  roleOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this.role_name.setValue(this.roles.find(x => x.role_id === value).role_name);
    }
    else {
      this.role_name.setValue(null);
    }
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get user_id() { return this.Form.get('user_id'); }
  get full_name() { return this.Form.get('full_name'); }
  get user_name() { return this.Form.get('user_name'); }
  get pwd() { return this.Form.get('pwd'); }
  get role_id() { return this.Form.get('role_id'); }
  get role_name() { return this.Form.get('role_name'); }
  get inactive() { return this.Form.get('inactive'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}



// WEBPACK FOOTER //
// ./src/app/master/user-list.component.ts